import get from 'lodash/get';
import { MATCHED_ID } from '@gtintel/platform-constants';
import { BatchType, PartnerProposalStatus } from '@gtintel/platform-types';
export function getPartnerData(partners, batchType, detailProject) {
  let status = '';
  const createInitialData = partner => {
    return {
      title: `${partner.first_name} ${partner.last_name}`,
      tags: partner.tags,
      street_address: partner.street_address,
      buttonMessage: 'MESSAGE',
      buttonSelect: 'Remove',
      style: true,
      avatar: partner.avatar,
      status,
      statusId: partner.proposal_status,
      id: partner.id
    };
  };
  const {
    PENDING,
    DECLINED
  } = PartnerProposalStatus;
  const pendingPartners = partners.some(partner => partner.proposal_status === PENDING);
  return partners.filter(partner => batchType !== BatchType.BATCH || partner.accept_batch).map(partner => {
    if (partner.proposal_status === DECLINED) {
      status = 'Declined';
    } else if (partner.proposal_status === PENDING) {
      status = +get(detailProject, 'status', 0) === +MATCHED_ID ? 'Matched' : 'Pending';
    } else {
      status = '';
    }
    const data = {
      ...partner,
      ...createInitialData(partner)
    };
    if (pendingPartners && (partner.proposal_status !== PENDING || detailProject?.status !== 1)) {
      data['buttonSelect'] = '';
    } else {
      data['buttonSelect'] = 'SELECT';
      data['style'] = false;
    }
    return data;
  });
}